import React, { Fragment, useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import styles from './Transmission.scss'

// Blue - general event - new entity/ new reservation
// Red - non filer
// Yellow - under report
const allowedTypes = ['regular', 'nonFiler', 'underReport']
const [TYPE_REGULAR] = allowedTypes

/**
 * Dan Abramov's useInterval hook from
 * https://overreacted.io/making-setinterval-declarative-with-react-hooks/
 * Thanks Dan!
 *
 * @param {*} callback
 * @param {*} delay
 */
function useInterval(callback, delay) {
  const savedCallback = useRef()

  useEffect(() => {
    savedCallback.current = callback
  }, [callback])

  useEffect(() => {
    function tick() {
      savedCallback.current()
    }

    if (delay !== null) {
      const id = setInterval(tick, delay)
      return () => clearInterval(id)
    }
  }, [delay])
}

const Transmission = ({ isReverse = false, type = TYPE_REGULAR, speed = 60, coordinates }) => {
  const [coordinatesIndex, setCoordinatesIndex] = useState(0)

  const [opacity, setOpacity] = useState(1)
  const [opacityDelta, setOpacityDelta] = useState(0.05)

  useInterval(() => {
    const nextIndex = coordinatesIndex + 1
    setCoordinatesIndex(nextIndex)

    const nextOpacity = opacity - opacityDelta
    if (nextOpacity <= 0.9 || nextOpacity >= 1) setOpacityDelta(opacityDelta * -1)

    setOpacity(nextOpacity)
  }, speed)

  return (
    <>
      {[0, 1, 2, 3].map(delta => {
        const currentIndex = isReverse ? coordinates.length - (coordinatesIndex + delta) : coordinatesIndex + delta

        if (currentIndex < 0 || currentIndex >= coordinates.length) return null

        const currentCoordinates = coordinates[currentIndex]
        const [currentCoordinateX, currentCoordinateY] = currentCoordinates

        if (!currentCoordinateX || !currentCoordinateY) return null

        return (
          <div
            key={delta}
            className={cx(styles.transmission, styles[`delta-${delta}`], styles[type])}
            style={{
              left: currentCoordinateX,
              top: currentCoordinateY,
              opacity,
            }}
          >
            <div className={cx(styles.inner, styles[`delta-${delta}`])} />
          </div>
        )
      })}
    </>
  )
}

Transmission.propTpyes = {
  type: PropTypes.string,
  isReverse: PropTypes.bool,
  speed: PropTypes.number,
  coordinates: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number)).isRequired,
}

export default Transmission
